// extracted by mini-css-extract-plugin
module.exports = {"ttOverviewListItem":"hPudVGH","btnContainer":"jGME_MV","menuItem":"PPMvNlR","timetableSelectionMenu":"bc_2jLD","timetableLabelInputContainer":"ob1NBqD"};